<template>
  <div class="coupon_index_index">
    <van-sticky>
      <van-tabs
        class="div-tab"
        :border="false"
        :active="active"
        @change="onChange"
        :ellipsis="false"
      >
        <van-tab title="全部" name=""></van-tab>
        <van-tab title="未使用" name="0"></van-tab>
        <van-tab title="已使用" name="1"></van-tab>
        <van-tab title="已过期" name="2"></van-tab>
      </van-tabs>
      <van-swipe
        v-if="infoList.length"
        class="info-swipe"
        vertical
        autoplay="2000"
        :touchable="false"
        :show-indicators="false"
        @click.native="onJumpToActivityReceive"
      >
        <van-swipe-item v-for="item of infoList" :key="item">
          <div class="info">
            <img
              class="icon-home"
              src="@/assets/image/coupon-info.png"
              alt=""
            />
            您有“{{ item }}”优惠券待领取
            <img
              class="icon-arrow-right"
              src="@/assets/image/arrow_icon@2x.png"
              alt=""
            />
          </div>
        </van-swipe-item>
      </van-swipe>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        style="min-height: 94vh"
        v-model="isLoading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        :finished-text="emptyVisible ? '' : '没有更多数据'"
        @load="onLoad"
      >
        <div class="byg">
          <!-- <div class="bkb" v-if="actId">
            <img @click="onJumpToActivity" src="@/assets/image/coupon_canget2@2x.png" />
          </div> -->
          <AdSwiper
            width="710"
            paddingBottom="20"
            code="my_platformcoupons_01_001"
            groupCode="my_platformcoupons_01"
            :refreshing="refreshing"
          />
          <div v-for="(item, index) in list" :key="index">
            <ListItem
              ref="itemCouponRef"
              :item="item"
              :isUsed="active"
              :status="
                active == '0'
                  ? 'userAvailableCouponList'
                  : 'unuserAvailableCouponList'
              "
             
              @refreshCoupon="onRefresh"
            />
          </div>
          <EmptyItem
            v-if="emptyVisible"
            :url="$theme.u_general_icon_empty"
            title="暂无相关优惠券"
            info
          ></EmptyItem>
          <van-button
            class="go_btn"
            v-if="emptyVisible"
            @click="goIndex"
            type="primary"
            >去逛逛</van-button
          >
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
import ListItem from "./components/item";
import ListItemBee from "./components/itemBee";
import EmptyItem from "@/views/shareDiscovery/components/emptyItem";
import AdSwiper from "@/components/ad/swiper";
import { isWeChatApplet } from "@/utils/util";
export default {
  data() {
    return {
      active: "0",
      error: false,
      refreshing: false,
      isLoading: false,
      finished: false,
      list: [],
      pageNum: 1,
      pageSize: 10,
      emptyVisible: false,
      callvisible: true,
      actId: "",
      actlink: "",
      popupShow: false,
      infoList: [],
    }
  },
  methods: {
    async onJumpToActivity() {
      if (await isWeChatApplet()) {
        utils.jumpToNewPage({
          url:
            window.location.origin +
            "/h5user/activityPreview?activityId=" +
            this.actId,
        });
      } else {
        this.$router.push({
          name: "activityPreview",
          query: { activityId: this.actId },
        });
      }
    },
    async onJumpToLink() {
      if (await isWeChatApplet()) {
        utils.jumpToNewPage({ url: this.actlink });
      } else {
        location.href = this.actlink;
      }
    },
    async onJumpToActivityReceive() {
      if (await isWeChatApplet()) {
        utils.jumpToNewPage({
          url: window.location.origin + "/h5user/activityReceive",
        });
      } else {
        this.$router.push({
          name: "activityReceive",
        });
      }
    },
    async goIndex() {
      if (await isWeChatApplet()) {
        utils.goPageByName({ id: "index", name: "首页" });
      } else {
        wx.miniProgram.switchTab({ url: "/pages/home/index" });
      }
    },
    onChange(tab) {
      console.log(tab, 444);
      this.active = tab;
      this.list = [];
      this.pageNum = 1;
      this.pageSize = 10;
      this.onLoad(tab);
    },
    onRefresh() {
      setTimeout(() => {
        this.pageNum = 1;
        this.list = [];
        //恢复不是最后一页
        this.refreshing = false;
        this.onLoad();
      }, 1000);
    },
    onLoad(tab) {
      this.isLoading = true;
      http({
        url: "order/coupon/getMyCoupon",
        method: "post",
        parmes: {
          pageIndex: this.pageNum,
          pageSize: this.pageSize,
          isUsed: tab || this.active, //0: 未使用1:已使用 2:已过期
        },
      })
        .then((rps) => {
          this.$loading.hide();
          this.error = false;
          if (rps.data.pages == 0) {
            this.finished = true;
            this.emptyVisible = true;
          } else {
            if (rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum++;
            }
            this.list = this.list.concat(rps.data.list);
            this.emptyVisible = false;
          }
          this.isLoading = false;
        })
        .catch((rps) => {
          this.error = true;
          this.$loading.hide();
        });
    },
    getWaitReceiveActivity() {
      http({
        url: "order/coupon/getWaitReceiveActivityId",
        method: "post",
      }).then((rps) => {
        if (rps.code == 200) {
          this.actId = rps.data;
        }
      });
    },
    getWaitReceiveActivityInfo() {
      http({
        url: "order/coupon/getWaitReceiveActivityInfo",
        method: "post",
      }).then((rps) => {
        if (rps.code == 200) {
          this.infoList = rps.data;
        }
      });
    },
    getPopupRule() {
      http({
        url: "order/coupon/getAvailableCouponActivityLink",
        method: "get",
      }).then((rps) => {
        if (rps.code == 200) {
          console.log(rps);
        }
      });
    },
  },
  created() {
    this.getWaitReceiveActivity();
    this.getWaitReceiveActivityInfo();
    this.getPopupRule();
  },
  watch: {},
  components: { ListItem, EmptyItem, ListItemBee, AdSwiper },
};
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
/deep/.van-sticky{
  z-index: 999;
}
/deep/.van-tabs__line {
  background-color: var(--buttonColor);
}
.byg {
  padding: 20px;
}
.bkb {
  padding-bottom: 20px;
  img {
    vertical-align: bottom;
  }
}
.ad-swiper {
  padding-top: 20px;
}
.info-swipe {
  height: 74px;
  font-size: 24px;
  background: #fff;
  border-top: 1px solid #f2f2f2;
  .info {
    height: 74px;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 50px;
    box-sizing: border-box;
  }
  .icon-home {
    width: 32px;
    height: 32px;
    margin-right: 20px;
  }
  .icon-arrow-right {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -20px;
    z-index: 1;
  }
}
.go_btn {
  width: 160px;
  height: 60px;
  background: var(--buttonColor);
  color: var(--textColor);
  border-radius: 32px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 33px;
  text-align: center;
  border: none;
  margin: 0 auto;
  display: block;
}
</style>
